import { colors } from '@material-ui/core';

export default {
  styleOverrides: {
    root: {
      backgroundColor: colors.blueGrey[50],
      color: colors.blue[800],
    },
    deletable: {
      '&:focus': {
        backgroundColor: colors.blueGrey[100],
      },
    },
  },
};
